<script setup></script>

<template>
  <div class="not-found">
    <h1>404 - 页面不存在</h1>
    <p>您访问的路径 {{ $route.path }} 不存在</p>
    <router-link to="/">返回上一页</router-link>
  </div>
</template>

<style scoped lang="scss">
.not-found {
  text-align: center;
  padding: 2rem;
}
</style>
